import "../../assets/css/argon-dashboard.min.css";
import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
} from "reactstrap";
 
import { toast } from 'react-toastify';
import { URL as ApiURL } from "../../api";
import axiosInstance from "../../Request";
import privilegeList from "../../PrivilegeList";

const FixedPlugin = (props) => {
   
const url = window.location.href;
const pathParts = new URL(url).pathname.split('/'); 
const cid = pathParts[3]; // The 5th segment (index 4)
const lid = pathParts[4]; // The 6th segment (index 5)
const [emailModalOpen, setEmailModalOpen] = useState(false);
const [emailSubject, setEmailSubject] = useState("");
const [emailBody, setEmailBody] = useState("");
const [smsModalOpen, setSmsModalOpen] = useState(false);
const [selectedSmsType, setSelectedSmsType] = useState("");
const [paymentNote, setPaymentNote] = useState("");
const [smsTypes, setSmsTypes] = useState([]);
const [loadingSmsTypes, setLoadingSmsTypes] = useState(true);
const [show, setShow] = useState(false);
const pluginRef = useRef(null);
const [emailCc, setEmailCc] = useState("");
const [emailBcc, setEmailBcc] = useState("");
const [customerStatusList, setCustomerStatusList] = useState({ customerStatuses: {} });
const [selectedCustomerStatusValue, setSelectedCustomerStatusValue] = useState("");
const [modalType, setModalType] = useState(null); // "lead" | "customer"



  const togglePlugin = () => {
    setShow(!show);
  };

const [commentModalOpen, setCommentModalOpen] = useState(false);
const [comment, setComment] = useState("");


const openCommentModal = () => setCommentModalOpen(true);
const closeCommentModal = () => {
  setCommentModalOpen(false);
  setComment(""); // optional: reset comment field
};

const handleLeadStatusChange = (event) => {
  const selectedStatusId = event.target.value;
  setSelectedLeadStatusValue(selectedStatusId);
if (selectedStatusId) {
  setModalType("lead");
  openCommentModal();
}
};

  const handleSubmitStatusUpdate = async () => {
  const userId = localStorage.getItem("user_id");

  if (!comment.trim()) {
    toast.error("Please enter a comment before submitting.");
    return;
  }

  try {
    const payload = {
      customer_id: cid,
      lead_id: lid,
      lead_status_id: selectedLeadStatusValue,
      comment_by: userId,
      comment: comment.trim(),
    };

    const response = await axiosInstance.post(ApiURL.UPDATE_LEAD_STATUS, payload, {
      withCredentials: true,
    });

    toast.success("Lead status updated successfully", { autoClose: 4000 });
    window.location.reload();
  } catch (error) {
    console.error("Failed to update lead status:", error);
    toast.error("Failed to update lead status");
  } finally {
    closeCommentModal(); // close modal after attempt
  }
};

const handleCustomerStatusChange = (event) => {
  const selectedStatusId = event.target.value;
  setSelectedCustomerStatusValue(selectedStatusId);
if (selectedStatusId) {
  setModalType("customer");
  openCommentModal();
}
};




const updateCustomerStatus = async () => {
  const userId = localStorage.getItem("user_id"); // ✅ add this line

  if (!comment.trim()) {
    toast.error("Please enter a comment before submitting.");
    return;
  }

  try {
    const payload = {
      customer_id: cid,
      lead_id: lid,
      customer_status_id: selectedCustomerStatusValue,
      comment_by: userId,
      comment: comment.trim(),
    };

    const response = await axiosInstance.post(ApiURL.UPDATE_CUSTOMER_STATUS, payload, {
      withCredentials: true,
    });

    toast.success("Customer status updated successfully", { autoClose: 4000 });
    window.location.reload();
  } catch (error) {
    console.error("Failed to update customer status:", error);
    toast.error("Failed to update customer status");
  } finally {
    closeCommentModal(); // close modal after attempt
  }
};


    const [selectedSalseAgentValue, setSelectedSalseAgentValue] = useState('');
    const handleSalseAgentChange = (event) => {
      setSelectedSalseAgentValue(event.target.value);
      console.log('Selected:', event.target.value);
  
      toast.success("Salse agent changed", {
        autoClose: 4000,
        position: "bottom-center",
      });
    };
const [selectedActionValue, setSelectedActionValue] = useState('');
const [okycModalOpen, setOkycModalOpen] = useState(false);
const [bankingModalOpen, setBankingModalOpen] = useState(false);
const [enachModalOpen, setEnachModalOpen] = useState(false);
const [amount, setAmount] = useState("")
const [paymentLinkURL, setPaymentLinkURL] = useState("");
const [enachLinkURL, setEnachLinkURL] = useState("");
const [bankingLinkURL, setBankingLinkURL] = useState("");
const [okycLinkURL, setOKycLinkURL] = useState("");
const [paymentModalOpen, setPaymentModel] = useState(false);
const [flag, setFlag] = useState(null);
const [amountDisabled, setAmountDisabled] = useState(false);

// ---- Payment reconciliation (payout vs Peday) ----
const todayISO = new Date().toISOString().split("T")[0];
const [recoFrom, setRecoFrom] = useState(todayISO);
const [recoTo, setRecoTo] = useState(todayISO);
const [recoData, setRecoData] = useState(null);
const [recoLoading, setRecoLoading] = useState(false);
const inr = (v) =>
  "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fetchPaymentReco = async () => {
  setRecoLoading(true);
  try {
    const response = await axiosInstance.get(ApiURL.PAYMENT_AUDIT_COUNTS, {
      params: { fromDate: recoFrom, toDate: recoTo },
    });
    setRecoData(response.data);
  } catch (error) {
    console.error("Failed to fetch payment reconciliation:", error);
    toast.error("Failed to fetch payment reconciliation");
    setRecoData(null);
  } finally {
    setRecoLoading(false);
  }
};


  const handleActionChange = (e) => {
  const value = e.target.value;
  setSelectedActionValue(value);
  switch (value) {
    case "send_sms":
      setSmsModalOpen(true);
      break;
    case "send_email":
      setEmailModalOpen(true);
      break;
    case "send_enach":
      setEnachModalOpen(true);
      break;
    case "send_okyc":
      setOkycModalOpen(true);
      break;
    case "send_banking":
      setBankingModalOpen(true);
      break;
    case "send_payment":
      setPaymentModel(true);
      break;
    default:
      break;
  }
};
  const [selectedLeadStatusValue, setSelectedLeadStatusValue] = useState('');
  const [selectedCreditAgentValue, setSelectedCreditAgentValue] = useState('');
  const handleCreditAgentChange = (event) => {
    setSelectedCreditAgentValue(event.target.value);
    toast.success("Credit agent changed", {
      autoClose: 4000,
      position: "bottom-center",
    });
  };
  const handleClickOutside = (event) => {
    if (pluginRef.current && !pluginRef.current.contains(event.target)) {
      setShow(false);
    }
  };
const [statusList, setStatusList] = useState({ loanStatuses: {} });
 const fetchStatusesOnClick = async () => {
  if (Object.keys(statusList.loanStatuses || {}).length === 0) { // Avoid refetching if already fetched
    try {
  const response = await axiosInstance.get(ApiURL.STATUSES, {
    withCredentials: true
  });
  const data = response.data;
  console.log("Fetched statuses:", data);
  setStatusList(data);
} catch (error) {
  console.error("Error fetching lead statuses:", error);
   }
}
};

const fetchCustomerStatusesOnClick = async () => {
  if (Object.keys(customerStatusList.customerStatuses || {}).length === 0) {
    try {
      const response = await axiosInstance.get(ApiURL.STATUSES, {
        withCredentials: true,
      });
      const data = response.data;
      console.log("Fetched customer statuses:", data);
      setCustomerStatusList(data);
    } catch (error) {
      console.error("Error fetching customer statuses:", error);
    }
  }
};




  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [mobileChecked, setMobileChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
const handleSend = async (type) => {
  const userId = localStorage.getItem("user_id");
  if (!userId || !cid) {
    toast.error("Missing customer or user ID");
    return;
  }
try {
  let okycUrl = `${ApiURL.OKYC_SEND}?customer_id=${cid}&user_id=${userId}`;
  if (type) {
    okycUrl += `&source=${type}`;
  }
  const response = await axiosInstance.get(okycUrl); // ✅ using axiosInstance
  const data = response.data;
  if (response.status !== 200 || data?.error) {
    const errorMsg = data?.error || "Failed to send";
    toast.error(errorMsg);
    return;
  }
  const url = data?.aadhaarResponse?.url;
  if (url) {
    setOKycLinkURL(url); // ✅ Set the link in state
  }
  toast.success(`OKYC link ${type ? "sent via " + type : "retrieved successfully"}`);
} catch (error) {
  toast.error(`Failed to ${type ? "send via " + type : "fetch the link"}`);
  console.error(error);
}
};
const handleSendBanking = async (type) => {
  const userId = localStorage.getItem("user_id");
  if (!userId || !cid) {
    toast.error("Missing customer or user ID");
    return;
  }
try {
  let bankingUrl = `${ApiURL.BANKING_SEND}?customer_id=${cid}&user_id=${userId}`;
  if (type) {
    bankingUrl += `&source=${type}`;
  }
  const response = await axiosInstance.get(bankingUrl); // ✅ axiosInstance used
  const data = response.data;
  const bankingResponse = data?.bankingResponse;
  const msg = bankingResponse?.msg || data?.error || "Unknown response";
if (!bankingResponse?.url) {
      toast.error(msg); // Show message as error if URL is missing
      return;
    }
  if (response.status !== 200 || data?.error) {
    const errorMsg = data?.error || "Failed to send";
    toast.error(errorMsg);
    return;
  }
  const url = data?.bankingResponse?.url;
  if (url) {
    setBankingLinkURL(url); // ✅ Set the link in state
  }
  toast.success(`Banking link ${type ? "sent via " + type : "retrieved successfully"}`);
} catch (error) {
  toast.error(`Failed to ${type ? "send via " + type : "fetch the link"}`);
  console.error(error);
}
}
const handleSendEnach = async (type) => {
  const userId = localStorage.getItem("user_id");
  if (!userId || !cid) {
    toast.error("Missing customer or user ID");
    return;
  }
try {
  let enachURL = `${ApiURL.ENACH_SEND}?customer_id=${cid}&user_id=${userId}`;
  if (type) {
    enachURL += `&source=${type}`;
  }
  const response = await axiosInstance.get(enachURL);
  const data = response.data;
   if (response.status !== 200 || data?.error) {
    const errorMsg = data?.error || "Failed to send";
     toast.error(errorMsg);
    return;
  }
  const url = data?.enachResponse?.short_url;
  if (url) {
    setEnachLinkURL(url); // ✅ Set the link in state
  }
  toast.success(`Enach link ${type ? "sent via " + type : "retrieved successfully"}`);
} catch (error) {
  toast.error(`Failed to ${type ? "send via " + type : "fetch the link"}`);
  console.error(error);
}
}
 const handleSendPaymentLink = async (type) => {
  const userId = localStorage.getItem("user_id");
  if (!userId || !cid) {
  toast.error("Missing customer ID or user ID");
  return;
}
try {
  let paymentLink = `${ApiURL.PaymentLink_SEND}?customer_id=${cid}&user_id=${userId}`;
  if (type) {
    paymentLink += `&source=${type}`;
  }

  if (!amount) {
    toast.error("Please enter the amount before generating the payment link");
    return;
  }

  if (amount) {
    paymentLink += `&amount=${amount}`;
  }

  if (flag) {
  paymentLink += `&flags=${flag}`;
}

  const response = await axiosInstance.get(paymentLink); 
  const data = response.data;

  if (response.status !== 200 || data?.error) {
    const errorMsg = data?.error || "Failed to send";
    toast.error(errorMsg);
    return;
  }

  if (type) {
    toast.success(`Payment link ${type ? "sent via " + type : "generated successfully"}`);
  } else {
    const url = data?.payInResponse?.link;
    if (url) {
      setPaymentLinkURL(url);
      toast.success("Payment link generated successfully");
    } else {
      toast.error("Link not found in response");
    }
   }
} catch (error) {
  toast.error(`Failed to ${type ? "send via " + type : "generate"} payment link`);
  console.error("Payment link error:", error);
}
};
const handleFlagChange = async (value) => {
  setFlag(value);
  setAmount("");
  setAmountDisabled(false);
  setPaymentLinkURL(""); // clear previously generated link if any

  if (value === 2 || value === 3) {
    try {
      const response = await axiosInstance.get(`${ApiURL.FORECLOSURE_SUMMARY}?customerId=${cid}`);
      const data = response.data;

      
      if (!data || Object.keys(data).length === 0) {
        toast.warning("No loans found or foreclosure already done.");
        setAmount("");
        return;
      }

      const values = Object.values(data || {});

      if (value === 2) {
        const firstEligible = values.find(item => item.foreclosure_total_amount > 0);

        if (!firstEligible) {
          toast.warning("Foreclosure already done or no eligible EMIs.");
           setAmount("");
           setAmountDisabled(true);
        } else {
          setAmount(firstEligible.foreclosure_total_amount);
          setAmountDisabled(true);
        }

      } else if (value === 3) {
        const firstEligible = values.find(item => item.force_foreclosure_total_amount > 0);

        if (!firstEligible) {
          toast.warning("Force Foreclosure already done.");
           setAmount("");
           setAmountDisabled(true);
        } else {
          setAmount(firstEligible.force_foreclosure_total_amount);
          setAmountDisabled(true);
        }
      }

    } catch (error) {
      toast.error("Failed to fetch foreclosure summary");
      console.error(error);
    }

  } else {
    setAmount("");
    setAmountDisabled(false);
  }
};
const closeModal = () => {
  setPaymentModel(false);
  setPaymentLinkURL(""); 
};
const closeModalEnach = () => {
  setEnachModalOpen(false);     //✅ Close modal
  setEnachLinkURL("");          
};
const closeModalBanking = () => {
  setBankingModalOpen(false);   // ✅ Close modal
  setBankingLinkURL("");        // ✅ Clear link
};
const closeModalOkyc = () => {
  setOkycModalOpen(false);      // ✅ Close modal
  setOKycLinkURL("");           // ✅ Clear link
};

useEffect(() => {
  if (smsModalOpen) {
    setLoadingSmsTypes(true);
    axiosInstance
      .get(ApiURL.TEMPLATE_NAME)
      .then((response) => {
        setSmsTypes(response.data || []);
      })
      .catch((error) => {
        console.error("Failed to fetch SMS types:", error);
        toast.error("Failed to load SMS types.");
      })
      .finally(() => {
        setLoadingSmsTypes(false);
      });
  }
}, [smsModalOpen]);




  return (
    <>
      <div ref={pluginRef} className={`fixed-plugin ${show ? "show" : ""}`}>
        <button className="fixed-plugin-button text-dark position-fixed px-3 py-2" onClick={togglePlugin}   style={{ cursor: "pointer", border: "none", background: "none" }}>
          <i className="fa fa-cog py-2"></i>
        </button>

        <div className="card shadow-lg">
          <div className="card-header pb-0 pt-3">
            <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
              <Card className="card-profile shadow">
                <CardBody className="pt-0 pt-md-4">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-action">Action</label>
                    <select value={selectedActionValue} onChange={handleActionChange}
                      className="form-control-alternative form-control" id="input-action">
                      <option value="">--Select Action--</option>
                      <option value="send_sms">Send Sms</option>
                      <option value="send_email">Send Email</option>
                      <option value="send_enach">Send Enach Link</option>
                      <option value="send_okyc">Send Okyc Link</option>
                      <option value="send_banking">Send Banking Link</option>
                      <option value="send_payment">Send Payment Link</option>
                    </select>
                  </FormGroup>
                  {privilegeList.statusChangeShow && (
                <FormGroup>
                    <Label className="form-control-label" htmlFor="lead_status">
                      Lead Status
                    </Label>
                    <select
                      className="form-control-alternative form-control w-100"
                      id="lead_status"
                      name="lead_status"
                      value={selectedLeadStatusValue}
                      onClick={fetchStatusesOnClick}
                      onChange={handleLeadStatusChange}
                    >
                      <option value="">--Select Lead Status--</option>
                      {statusList.loanStatuses &&
                        Object.entries(statusList.loanStatuses).map(([label, id]) => (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        ))}
                    </select>
                  </FormGroup>
                  )}
                  
                  {privilegeList.statusChangeShow && (
                  <FormGroup>
                      <Label className="form-control-label" htmlFor="customer_status">
                        Customer Status
                      </Label>
                      <select
                        className="form-control-alternative form-control w-100"
                        id="customer_status"
                        name="customer_status"
                        value={selectedCustomerStatusValue}
                        onClick={fetchCustomerStatusesOnClick}
                        onChange={handleCustomerStatusChange}
                      >
                        <option value="">--Select Customer Status--</option>
                        {customerStatusList.customerStatuses &&
                          Object.entries(customerStatusList.customerStatuses).map(([label, id]) => (
                            <option key={id} value={id}>
                              {label}
                            </option>
                          ))}
                      </select>
                    </FormGroup>
                  )}

                  <Modal isOpen={commentModalOpen} toggle={closeCommentModal} centered>
  <ModalHeader toggle={closeCommentModal}>Add Comment</ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label className="form-control-label" htmlFor="comment">
        Comment
      </Label>
      <Input
        type="textarea"
        id="comment"
        name="comment"
        placeholder="Enter comment for status change..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
    </FormGroup>
  </ModalBody>
  <ModalFooter>
    {modalType === "lead" ? (
      <Button color="primary" onClick={handleSubmitStatusUpdate}>
        Update Lead Status
      </Button>
    ) : (
      <Button color="primary" onClick={updateCustomerStatus}>
        Save Customer Status
      </Button>
    )}
    <Button color="secondary" onClick={closeCommentModal}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>



                  {privilegeList.salesAgentShow && (
                  <FormGroup>
                    <label className="form-control-label" htmlFor="sales-agent">Sales Agent</label>
                    <select value={selectedSalseAgentValue} onChange={handleSalseAgentChange}
                      className="form-control-alternative form-control" id="sales-agent">
                      <option value="">--Select Sales agent--</option>
                      <option value="user1">User 1</option>
                      <option value="user2">User 2</option>
                      <option value="user3">User 3</option>
                    </select>
                  </FormGroup>
                  )}
                  {privilegeList.creditAgentShow && (
                  <FormGroup>
                    <label className="form-control-label" htmlFor="credit-agent">Credit Agent</label>
                    <select value={selectedCreditAgentValue} onChange={handleCreditAgentChange}
                      className="form-control-alternative form-control" id="credit-agent">
                      <option value="">--Select Credit agent--</option>
                      <option value="user1">User 1</option>
                      <option value="user2">User 2</option>
                      <option value="user3">User 3</option>
                    </select>
                  </FormGroup>
                  )}

                  {/* ---- Payment Reconciliation (date-wise payout vs Peday) ---- */}
                  <hr className="my-3" />
                  <label className="form-control-label font-weight-bold">Payment Reco</label>
                  <div className="d-flex" style={{ gap: "6px" }}>
                    <FormGroup className="mb-2 flex-fill">
                      <Label className="form-control-label small">From</Label>
                      <Input type="date" bsSize="sm" value={recoFrom} max={todayISO}
                        onChange={(e) => setRecoFrom(e.target.value)} />
                    </FormGroup>
                    <FormGroup className="mb-2 flex-fill">
                      <Label className="form-control-label small">To</Label>
                      <Input type="date" bsSize="sm" value={recoTo} max={todayISO}
                        onChange={(e) => setRecoTo(e.target.value)} />
                    </FormGroup>
                  </div>
                  <Button color="primary" size="sm" block onClick={fetchPaymentReco} disabled={recoLoading}>
                    {recoLoading ? "Loading…" : "Fetch Reco"}
                  </Button>

                  {recoData && (
                    <div className="mt-3 p-2 border rounded bg-light" style={{ fontSize: "12px" }}>
                      <div className="d-flex justify-content-between">
                        <span>Withdrawal ({String(recoData.withdrawalCount || 0)})</span>
                        <strong>{inr(recoData.withdrawalAmount)}</strong>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Processing Fee ({String(recoData.processingFeeCount || 0)})</span>
                        <strong>{inr(recoData.processingFee)}</strong>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>GST (18%)</span>
                        <strong>{inr(recoData.gstAmount)}</strong>
                      </div>
                      <hr className="my-1" />
                      <div className="d-flex justify-content-between text-primary">
                        <span className="font-weight-bold">Total Payout</span>
                        <strong>{inr(recoData.totalPayout)}</strong>
                      </div>
                      <div className="d-flex justify-content-between mt-1 text-muted">
                        <span>Payin / Payout (txn)</span>
                        <span>{String(recoData.payin || 0)} / {String(recoData.payout || 0)}</span>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </div>
        </div>
      </div>
         <Modal isOpen={okycModalOpen} toggle={closeModalOkyc}>
  <ModalHeader toggle={closeModalOkyc}>Send Okyc Link</ModalHeader>
        <ModalBody>
          <FormGroup check className="d-flex align-items-center justify-content-between">
            <Label check className="mb-0">
              <Input type="checkbox" checked={mobileChecked} onChange={(e) => {
                const checked = e.target.checked;
                setMobileChecked(checked);
                if (checked) setEmailChecked(false);
              }} /> Mobile Number
            </Label>
            {mobileChecked && (
              <Button color="primary" size="sm" onClick={() => handleSend("mobile")}>Send</Button>
            )}
          </FormGroup>
          <FormGroup check className="d-flex align-items-center justify-content-between mt-2">
            <Label check className="mb-0">
              <Input type="checkbox" checked={emailChecked} onChange={(e) => {
                const checked = e.target.checked;
                setEmailChecked(checked);
                if (checked) setMobileChecked(false);
              }} /> Email
            </Label>
            {emailChecked && (
              <Button color="primary" size="sm" onClick={() => handleSend("email")}>Send</Button>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter className="justify-content-start">
          <Button color="primary" onClick={() => handleSend(null)}>
            <i className="fa fa-link me-2"></i> Generate URl
          </Button>
      {okycLinkURL && (
    <div className="mt-3 w-100">
      <Label className="fw-bold">Generated Link:</Label>
      <div className="p-2 bg-light border rounded" style={{ wordBreak: "break-word" }}>
        <a href={okycLinkURL} target="_blank" rel="noopener noreferrer">
          {okycLinkURL}
        </a>
      </div>
    </div>
   )}
        </ModalFooter>
      </Modal>
         <Modal isOpen={bankingModalOpen} toggle={closeModalBanking}>
  <ModalHeader toggle={closeModalBanking}>Send Banking Link</ModalHeader>
        <ModalBody>
          <FormGroup check className="d-flex align-items-center justify-content-between">
            <Label check className="mb-0">
              <Input type="checkbox" checked={mobileChecked} onChange={(e) => {
                const checked = e.target.checked;
                setMobileChecked(checked);
                if (checked) setEmailChecked(false);
              }} /> Mobile Number
            </Label>
            {mobileChecked && (
              <Button color="primary" size="sm" onClick={() => handleSendBanking("mobile")}>Send</Button>
            )}
          </FormGroup>
          <FormGroup check className="d-flex align-items-center justify-content-between mt-2">
            <Label check className="mb-0">
              <Input type="checkbox" checked={emailChecked} onChange={(e) => {
                const checked = e.target.checked;
                setEmailChecked(checked);
                if (checked) setMobileChecked(false);
              }} /> Email
            </Label>
            {emailChecked && (
              <Button color="primary" size="sm" onClick={() => handleSendBanking("email")}>Send</Button>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter className="justify-content-start">
          <Button color="primary" onClick={() => handleSendBanking(null)}>
            <i className="fa fa-link me-2"></i> Generate URl
          </Button>
  {bankingLinkURL && (
  <div className="mt-3 w-100">
    <Label className="fw-bold">Generated Link:</Label>
    <div
      className="p-3 bg-light border rounded"
      style={{
        wordBreak: "break-word",
        minHeight: "80px", // Increased height
        fontSize: "1rem",  // Slightly larger font
      }}
    >
      <a
        href={bankingLinkURL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "#0d6efd" }}
      >
        {bankingLinkURL}
      </a>
    </div>
  </div>
)}
         </ModalFooter>
      </Modal>
        <Modal isOpen={enachModalOpen} toggle={closeModalEnach}>
  <ModalHeader toggle={closeModalEnach}>Send Enach Link</ModalHeader>
        <ModalBody>
          <FormGroup check className="d-flex align-items-center justify-content-between">
            <Label check className="mb-0">
              <Input type="checkbox" checked={mobileChecked} onChange={(e) => {
                const checked = e.target.checked;
                setMobileChecked(checked);
                if (checked) setEmailChecked(false);
              }} /> Mobile Number
            </Label>
            {mobileChecked && (
              <Button color="primary" size="sm" onClick={() => handleSendEnach("mobile")}>Send</Button>
            )}
          </FormGroup>
          <FormGroup check className="d-flex align-items-center justify-content-between mt-2">
            <Label check className="mb-0">
              <Input type="checkbox" checked={emailChecked} onChange={(e) => {
                const checked = e.target.checked;
                setEmailChecked(checked);
                if (checked) setMobileChecked(false);
              }} /> Email
            </Label>
            {emailChecked && (
              <Button color="primary" size="sm" onClick={() => handleSendEnach("email")}>Send</Button>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter className="justify-content-start">
          <Button color="primary" onClick={() => handleSendEnach(null)}>
            <i className="fa fa-link me-2"></i> Generate URl
          </Button>
    {enachLinkURL && (
    <div className="mt-3 w-100">
      <Label className="fw-bold">Generated Link:</Label>
      <div className="p-2 bg-light border rounded" style={{ wordBreak: "break-word" }}>
        <a href={enachLinkURL} target="_blank" rel="noopener noreferrer">
          {enachLinkURL}
        </a>
      </div>
    </div>
  )}
        </ModalFooter>
      </Modal>
          <Modal isOpen={paymentModalOpen} toggle={closeModal}>
            <ModalHeader toggle={closeModal}>Send Payment Link</ModalHeader>
            <ModalBody>
             <FormGroup className="mb-3">
              <Label className="fw-bold">Select Payment Type:</Label>
              <Input
                type="select"
                value={flag}
                onChange={(e) => handleFlagChange(Number(e.target.value))}
              >
                <option value="">-- Select Payment Type --</option>
                <option value={1}>Normal Payment</option>
                <option value={2}>Foreclosure Payment</option>
                <option value={3}>Force Foreclosure Payment</option>
              </Input>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label for="amountInput">Enter Amount</Label>
              <Input
                type="number"
                id="amountInput"
                placeholder="Enter amount"
                value={amount}
                disabled={amountDisabled}
                onChange={(e) => setAmount(e.target.value)}
              />
            </FormGroup>
              <Label className="fw-bold">Select Communication Method:</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={mobileChecked}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setMobileChecked(checked);
                      if (checked) setEmailChecked(false);
                    }}
                  />{" "}
                  Mobile Number
                </Label>
              </FormGroup>
              <FormGroup check className="mt-2">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={emailChecked}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setEmailChecked(checked);
                      if (checked) setMobileChecked(false);
                    }}
                  />{" "}
                  Email
                </Label>
              </FormGroup>
            </ModalBody>
            <ModalFooter className="justify-content-start">
             <Button
                  color="primary"
                  onClick={() => {
                    if (!flag) {
                      toast.error("Please select a Payment Type before generating the link.");
                      return;
                    }
                    if (flag === 2 && !amount) {
                      toast.error("Foreclosure can't be done. For Foreclosure Eligible EMIs are not paid.");
                      return;
                    }

                    const selectedType = mobileChecked
                      ? "mobile"
                      : emailChecked
                      ? "email"
                      : null;

                    handleSendPaymentLink(selectedType);
                  }}
                >
                  <i className="fa fa-link me-2"></i> Generate URL
                </Button>
             {paymentLinkURL && (
              <div className="mt-3 w-100">
                <Label className="fw-bold">Generated Link:</Label>
                <div className="p-2 bg-light border rounded d-flex justify-content-between align-items-center" style={{ wordBreak: "break-word" }}>
                  <span className="me-2 text-truncate" style={{ maxWidth: "85%" }}>
                    {paymentLinkURL}
                  </span>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => {
                      navigator.clipboard.writeText(paymentLinkURL);
                      toast.success("Link copied to clipboard");
                    }}
                  >
                    Copy
                  </Button>
                </div>
              </div>
            )}
            </ModalFooter>
          </Modal>
<Modal isOpen={emailModalOpen} toggle={() => setEmailModalOpen(false)}>
  <ModalHeader toggle={() => setEmailModalOpen(false)}>Send Email</ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label for="emailSubject">Subject</Label>
      <Input
        id="emailSubject"
        type="text"
        value={emailSubject}
        onChange={(e) => setEmailSubject(e.target.value)}
        placeholder="Enter email subject"
      />
    </FormGroup>
    <FormGroup>
      <Label for="emailBody">Body</Label>
      <Input
        id="emailBody"
        type="textarea"
        rows="5"
        value={emailBody}
        onChange={(e) => setEmailBody(e.target.value)}
        placeholder="Enter email body"
      />
    </FormGroup>
    <FormGroup>
  <Label for="emailCc">CC</Label>
  <Input
    id="emailCc"
    type="text"
    value={emailCc}
    onChange={(e) => setEmailCc(e.target.value)}
    placeholder="Comma-separated CC emails"
  />
</FormGroup>
<FormGroup>
  <Label for="emailBcc">BCC</Label>
  <Input
    id="emailBcc"
    type="text"
    value={emailBcc}
    onChange={(e) => setEmailBcc(e.target.value)}
    placeholder="Comma-separated BCC emails"
  />
</FormGroup>
  </ModalBody>
  <ModalFooter>
<Button
  color="primary"
  onClick={async () => {
    const userId = localStorage.getItem("user_id");
    if (!cid || !userId || !emailSubject || !emailBody) {
      toast.error("All fields are required.");
      return;
    }

    const payload = {
      customer_id: cid,
      user_id: userId,
      subject: emailSubject,
      body: emailBody,
    };

    if (emailCc.trim()) {
      payload.cc = emailCc.split(",").map(e => e.trim());
    }

    if (emailBcc.trim()) {
      payload.bcc = emailBcc.split(",").map(e => e.trim());
    }

    try {
     const response = await axiosInstance.post(ApiURL.MANUAL_EMAIL, payload);

      const data = response.data;

      if (data?.error) {
        toast.error(data.error);
      } else {
        toast.success("Email sent successfully!");
        setEmailModalOpen(false);
        setEmailSubject("");
        setEmailBody("");
        setEmailCc("");
        setEmailBcc("");
      }
    } catch (error) {
      toast.error("Failed to send email.");
      console.error("Send email error:", error);
    }
  }}
>
  Send
</Button>



    <Button color="secondary" onClick={() => setEmailModalOpen(false)}>Cancel</Button>
  </ModalFooter>
</Modal>

<Modal isOpen={smsModalOpen} toggle={() => setSmsModalOpen(false)}>
  <ModalHeader toggle={() => setSmsModalOpen(false)}>Send SMS</ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label for="smsTypeSelect">Select SMS Type</Label>
      <Input
        type="select"
        id="smsTypeSelect"
        value={selectedSmsType}
        onChange={(e) => setSelectedSmsType(e.target.value)}
      >
        <option value="">-- Select Type --</option>
        {smsTypes.map((type) => (
          <option key={type} value={type}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </option>
        ))}
      </Input>
    </FormGroup>

    {selectedSmsType === "payment" && (
      <FormGroup>
        <Label for="paymentNote">Body</Label>
        <Input
          type="textarea"
          id="paymentNote"
          placeholder="Enter payment writeup or notes..."
          value={paymentNote}
          onChange={(e) => setPaymentNote(e.target.value)}
        />
      </FormGroup>
    )}
  </ModalBody>
  <ModalFooter>
  <Button
    color="primary"
    disabled={!selectedSmsType}
    onClick={async () => {
      if (!cid) {
        toast.error("Customer ID (cid) is missing.");
        return;
      }

      try {
        const payload = {
          customerId: cid, // 👈 Ensure `cid` is a valid customer ID
          templateName: selectedSmsType, // 👈 This comes from the dropdown
        };

        const response = await axiosInstance.post(ApiURL.EXTERNAL_SMS, payload);

        if (response.status === 200 && response.data.status === "success") {
          toast.success("SMS sent successfully!");
          console.log("Customer ID:", response.data.customerId); // ✅ Shows in console
          setSmsModalOpen(false);
          setSelectedSmsType("");
          setPaymentNote("");
        } else {
          toast.error("Failed to send SMS.");
        }
      } catch (error) {
        console.error("Error sending SMS:", error);
        toast.error("Error sending SMS.");
      }
    }}
  >
    Send SMS
  </Button>
  <Button color="secondary" onClick={() => setSmsModalOpen(false)}>
    Cancel
  </Button>
</ModalFooter>

</Modal>


    </>
  );
};
export default FixedPlugin;